import React from "react"
import Breadcrumb from '../components/breadcrumb';

export default class Banner extends React.Component 
{
    constructor(props) 
    {
        super(props);              

        this.requestImageFile = require.context('../images/backgrounds', true, /.jpg$/); 

        this.code = this.props.code;  
        this.codes = this.props.codes;
        this.place = this.props.place;
        this.keygroup_name = this.props.keygroup_name;

        this.background = this.code+'-banner.jpg';         

        this.title = this.props.title;
    }

    render() 
    {
        return (
            <div className="banner">
                <div className="container-fluid">
                    <section className="row">
                        <div className="image-filter"></div>
                        <div className="header-image header-image-home col-12" style={ {backgroundImage: `url(${this.requestImageFile(`./${this.background}`)})`} }>
                            
                            <Breadcrumb 
                                code={this.code} 
                                place={this.place} 
                                keygroup_name={this.keygroup_name}
                                codes = {this.codes}
                                bread={this.props.bread}
                                url={this.props.url}/>
                            
                            <div className="row justify-content-center align-items-center h-100">
                                <div className="col-md-12 col-lg-8 hero-title text-center">
                                    <h1>{this.title}</h1>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="row title">
                        <div className="col-12">
                            <h3 className="justify-content-center text-white">{this.props.bottomtext}</h3>
                        </div>
                    </section>
                </div>
            </div>
        )
    }
}